import { MobileNavigation } from "components/navigation"
import { useAppUI } from "providers/ui"

export const AppNavigation = () => {
  const { sideMenus, mainMenus, matchedPath } = useAppUI()

  return (
    <MobileNavigation
      value={matchedPath?.to}
      bottomNavigations={mainMenus}
      navigations={sideMenus}
    />
  )
}
